import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';

const MenuContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 60px;
`;

const MenuItemContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px;
    font-family: 'Bebas Neue', cursive;
    font-size: 1rem;
    height: 100%;
    &:hover {
        background-color: #06CAFF;
        opacity: 0.6;
        color: #ffffff;
        cursor: pointer;
    }
`;

const MenuItem = ({ text }) => {
    return (
        <MenuItemContainer>
            { text }
        </MenuItemContainer>
    )
}

const MenuSection = styled.section`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 60px;
    background-color: rgba(255, 255, 255, 0.6);
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
`;

const Menu = () => {
    return (
        <MenuSection>
            <div style={{
                width: '1080px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <img 
                    className="w-auto h-[30px] m-2"
                    src={require('./logo-sm.png')}
                    alt="logo"
                />

                <MenuContainer>
                    <MenuItem text={'Réserver un trajet'} />
                    <MenuItem text={'Services'} />
                    <MenuItem text={'Transferts ski'} />
                    <MenuItem text={'Paiement CB'} />
                    <MenuItem text={'Contact'} />
                </MenuContainer>

            </div>
        </MenuSection>
    );
}

export default Menu;